"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncSingleShipToAfterLogin = void 0;
const Constants_1 = require("@/Constants");
const user_1 = require("@/Endpoints/user");
const CookieManager_1 = require("./CookieManager");
const getSingleShipToCustomerId = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const response = yield (0, user_1.getShippingAccounts)();
    const shipTos = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.shipTos) !== null && _b !== void 0 ? _b : [];
    if (shipTos.length !== 1) {
        return undefined;
    }
    return (_c = shipTos[0]) === null || _c === void 0 ? void 0 : _c.customerId;
});
const syncSingleShipToAfterLogin = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerId = yield getSingleShipToCustomerId();
        if (!customerId) {
            return {
                isSuccess: true,
                isSingleShipToDetected: false
            };
        }
        const setShipToResponse = yield (0, user_1.setUserShipToAccount)(customerId);
        if (!(setShipToResponse === null || setShipToResponse === void 0 ? void 0 : setShipToResponse.successful)) {
            return {
                isSuccess: false,
                isSingleShipToDetected: true,
                errorMessage: setShipToResponse === null || setShipToResponse === void 0 ? void 0 : setShipToResponse.errorMessage
            };
        }
        (0, CookieManager_1.setCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED, 'true', 1);
        return {
            isSuccess: true,
            isSingleShipToDetected: true
        };
    }
    catch (error) {
        return {
            isSuccess: false,
            isSingleShipToDetected: false,
            errorMessage: error instanceof Error ? error.message : 'Failed to sync ship-to after login'
        };
    }
});
exports.syncSingleShipToAfterLogin = syncSingleShipToAfterLogin;
